import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=4d45b3bb&scoped=true&"
import script from "./EventDetails.vue?vue&type=script&lang=ts&"
export * from "./EventDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45b3bb",
  null
  
)

export default component.exports